module.exports = __webpack_public_path__ + "img/titleEn.c920c8ef.png";